export default __webpack_public_path__ + "static/17-b00b58b669ad5ffc8788436e3e037820.jpg";